
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 800 500"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#4AADD6","d":"M0 0h800v500H0z"}}),_c('circle',{attrs:{"fill":"#FFDE00","cx":"350","cy":"250","r":"150"}})])
          )
        }
      }
    